import { useAppDispatch } from "../../../../../common/state/hooks";
import { update } from "../../../../../common/state/Slices/ConnectedDeviceSlice";
import { FetchDeviceListResponseBody } from "../../models/body";
import { GarudaResponse } from "../../models/events";

export const useResponseFoundHandler = () => {
    const dispatch = useAppDispatch();

    const handleOnConnectedDeviceFound = (response: GarudaResponse) => {
        const body = response.body as FetchDeviceListResponseBody;
        dispatch(update({ payload: body.device_details }));
    };

    return {
        handleOnConnectedDeviceFound
    };
};